// extracted by mini-css-extract-plugin
export default {"layout":"HomeBlock_layout__J9bIB","tagline":"HomeBlock_tagline__Rwgkm","question_block":"HomeBlock_question_block__yvC6z"};